var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpleado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empleado_svg__clip0_2572_59517)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empleado_svg__clip1_2572_59517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.987 13.38c-21.347-16.032-28.23-.805-46.703 5.528-14.732 5.046-35.926-1.44-48.152 10.393-10.654 10.305-7.873 32.437-.087 43.415 9.49 13.373 26.742 14.987 41.924 8.557 11.567-4.907 19.343-24.153 32.225-23.564 14.822.697 15.506 19.235 30.987 18.207 40.29-2.68 4.632-51.408-10.194-62.536z",
    fill: "#E5F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.178 64.552H40.887c-.3 0-.544.243-.544.543v8.88c0 .301.243.545.543.545h21.292c.3 0 .544-.244.544-.544v-8.88c0-.3-.244-.544-.544-.544z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M62.178 64.552H40.887c-.3 0-.544.243-.544.543v8.88c0 .301.243.545.543.545h21.292c.3 0 .544-.244.544-.544v-8.88c0-.3-.244-.544-.544-.544z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.175 64.552H40.877a.543.543 0 00-.544.543v2.848l11.083 2.182a.513.513 0 00.206 0l11.086-2.182v-2.847a.543.543 0 00-.533-.544z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.642 60.906H56.14v-1.09a1.704 1.704 0 00-1.7-1.702h-5.81a1.705 1.705 0 00-1.702 1.701v1.091h-6.5a.537.537 0 00-.536.537v5.37a.54.54 0 00.432.527l11.107 2.185c.068.01.138.01.206 0l11.107-2.185a.544.544 0 00.436-.526v-5.371a.536.536 0 00-.537-.537zm-14.422-1.09a.415.415 0 01.408-.412h5.81a.414.414 0 01.408.411v1.091h-6.622l-.004-1.09z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M62.642 60.906H56.14v-1.09a1.704 1.704 0 00-1.7-1.702h-5.81a1.705 1.705 0 00-1.702 1.701v1.091h-6.5a.537.537 0 00-.536.537v5.37a.54.54 0 00.432.527l11.107 2.185c.068.01.138.01.206 0l11.107-2.185a.544.544 0 00.436-.526v-5.371a.536.536 0 00-.537-.537zm-14.422-1.09a.415.415 0 01.408-.412h5.81a.414.414 0 01.408.411v1.091h-6.622l-.004-1.09z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.681 68.058h-2.293a.516.516 0 00-.516.515v1.45c0 .285.231.516.516.516h2.293c.285 0 .516-.23.516-.516v-1.45a.516.516 0 00-.516-.515z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M52.681 68.058h-2.293a.516.516 0 00-.516.515v1.45c0 .285.231.516.516.516h2.293c.285 0 .516-.23.516-.516v-1.45a.516.516 0 00-.516-.515z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.178.438H40.887c-.3 0-.544.243-.544.543v8.88c0 .3.243.544.543.544h21.292c.3 0 .544-.243.544-.543V.982c0-.301-.244-.544-.544-.544z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M62.178.438H40.887c-.3 0-.544.243-.544.543v8.88c0 .3.243.544.543.544h21.292c.3 0 .544-.243.544-.543V.982c0-.301-.244-.544-.544-.544z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.175.438H40.877a.543.543 0 00-.544.543V3.83L51.416 6.01a.513.513 0 00.206 0L62.708 3.83V.98a.543.543 0 00-.533-.543z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.642-3.208H56.14V-4.3A1.704 1.704 0 0054.439-6h-5.81a1.705 1.705 0 00-1.702 1.7v1.092h-6.5a.537.537 0 00-.536.536V2.7a.537.537 0 00.432.526L51.43 5.397a.512.512 0 00.206 0l11.107-2.185a.54.54 0 00.44-.513v-5.37a.537.537 0 00-.54-.537zM48.22-4.3a.411.411 0 01.408-.411h5.81a.411.411 0 01.408.407v1.091h-6.622l-.004-1.087z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M62.642-3.208H56.14V-4.3A1.704 1.704 0 0054.439-6h-5.81a1.705 1.705 0 00-1.702 1.7v1.092h-6.5a.537.537 0 00-.536.536V2.7a.537.537 0 00.432.526L51.43 5.397a.512.512 0 00.206 0l11.107-2.185a.54.54 0 00.44-.513v-5.37a.537.537 0 00-.54-.537zM48.22-4.3a.411.411 0 01.408-.411h5.81a.411.411 0 01.408.407v1.091h-6.622l-.004-1.087z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.681 3.947h-2.293a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516h2.293c.285 0 .516-.231.516-.516v-1.45a.516.516 0 00-.516-.516z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M52.681 3.947h-2.293a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516h2.293c.285 0 .516-.231.516-.516v-1.45a.516.516 0 00-.516-.516z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.013 64.552H7.72c-.3 0-.543.243-.543.543v8.88c0 .301.243.545.543.545h21.292c.3 0 .544-.244.544-.544v-8.88c0-.3-.244-.544-.544-.544z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.013 64.552H7.72c-.3 0-.543.243-.543.543v8.88c0 .301.243.545.543.545h21.292c.3 0 .544-.244.544-.544v-8.88c0-.3-.244-.544-.544-.544z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.027 64.552H7.72a.544.544 0 00-.543.543v2.848l11.083 2.182a.53.53 0 00.209 0l11.087-2.182v-2.847a.544.544 0 00-.53-.544z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.473 60.906h-6.504v-1.09a1.705 1.705 0 00-1.7-1.702h-5.807a1.704 1.704 0 00-1.701 1.701v1.091H7.257a.537.537 0 00-.536.537v5.37a.54.54 0 00.432.527l11.107 2.185c.07.01.14.01.21 0l11.107-2.185a.54.54 0 00.432-.526v-5.371a.537.537 0 00-.537-.537zm-14.422-1.09a.419.419 0 01.41-.412h5.807a.418.418 0 01.411.411v1.091h-6.622l-.007-1.09z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.473 60.906h-6.504v-1.09a1.705 1.705 0 00-1.7-1.702h-5.807a1.704 1.704 0 00-1.701 1.701v1.091H7.257a.537.537 0 00-.536.537v5.37a.54.54 0 00.432.527l11.107 2.185c.07.01.14.01.21 0l11.107-2.185a.54.54 0 00.432-.526v-5.371a.537.537 0 00-.537-.537zm-14.422-1.09a.419.419 0 01.41-.412h5.807a.418.418 0 01.411.411v1.091h-6.622l-.007-1.09z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.512 68.058H17.22a.516.516 0 00-.516.515v1.45c0 .285.231.516.516.516h2.293c.285 0 .516-.23.516-.516v-1.45a.516.516 0 00-.516-.515z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.512 68.058H17.22a.516.516 0 00-.516.515v1.45c0 .285.231.516.516.516h2.293c.285 0 .516-.23.516-.516v-1.45a.516.516 0 00-.516-.515z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.013.438H7.72c-.3 0-.543.243-.543.543v8.88c0 .3.243.544.543.544h21.292c.3 0 .544-.243.544-.543V.982c0-.301-.244-.544-.544-.544z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.013.438H7.72c-.3 0-.543.243-.543.543v8.88c0 .3.243.544.543.544h21.292c.3 0 .544-.243.544-.543V.982c0-.301-.244-.544-.544-.544z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.027.438H7.72a.544.544 0 00-.543.543V3.83L18.26 6.01c.069.014.14.014.209 0L29.557 3.83V.98a.544.544 0 00-.53-.543z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.473-3.208h-6.504V-4.3A1.705 1.705 0 0021.269-6h-5.807a1.704 1.704 0 00-1.701 1.7v1.092H7.257a.537.537 0 00-.536.536V2.7a.537.537 0 00.432.526L18.26 5.397c.07.014.14.014.21 0l11.107-2.185a.537.537 0 00.432-.527v-5.357a.537.537 0 00-.537-.536zM15.05-4.3a.415.415 0 01.41-.411h5.807a.415.415 0 01.411.407v1.091h-6.622l-.007-1.087z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.473-3.208h-6.504V-4.3A1.705 1.705 0 0021.269-6h-5.807a1.704 1.704 0 00-1.701 1.7v1.092H7.257a.537.537 0 00-.536.536V2.7a.537.537 0 00.432.526L18.26 5.397c.07.014.14.014.21 0l11.107-2.185a.537.537 0 00.432-.527v-5.357a.537.537 0 00-.537-.536zM15.05-4.3a.415.415 0 01.41-.411h5.807a.415.415 0 01.411.407v1.091h-6.622l-.007-1.087z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.512 3.947H17.22a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516h2.293c.285 0 .516-.231.516-.516v-1.45a.516.516 0 00-.516-.516z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.512 3.947H17.22a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516h2.293c.285 0 .516-.231.516-.516v-1.45a.516.516 0 00-.516-.516z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.237 42.463H7.72a.547.547 0 01-.547-.547v-8.877a.54.54 0 01.164-.384.544.544 0 01.383-.16h17.527a22.859 22.859 0 00-.142 3.667c0 .198 0 .397.03.592.025.366.053.736.095 1.101.18 1.566.517 3.11 1.007 4.608z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.237 42.463H7.72a.547.547 0 01-.547-.547v-8.877a.54.54 0 01.164-.384.544.544 0 01.383-.16h17.527a22.859 22.859 0 00-.142 3.667c0 .198 0 .397.03.592.025.366.053.736.095 1.101.18 1.566.517 3.11 1.007 4.608z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.249 32.495a22.859 22.859 0 00-.143 3.667c0 .198 0 .397.031.592l-5.11 1.004-1.56.307a.412.412 0 01-.206 0l-1.558-.304-9.525-1.875v-2.85a.59.59 0 01.042-.21.752.752 0 01.048-.09.385.385 0 01.07-.08.544.544 0 01.383-.16H25.25z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.977 28.85h-3.005v-1.092a1.708 1.708 0 00-1.704-1.7h-5.806a1.7 1.7 0 00-1.701 1.7v1.091H7.257a.536.536 0 00-.536.537v5.367a.54.54 0 00.435.53h.021l9.526 1.879 1.557.303a.512.512 0 00.206 0l1.561-.307 5.078-1c-.05-1.224-.003-2.45.143-3.667.145-1.231.389-2.45.729-3.642zM15.05 27.757a.414.414 0 01.412-.407h5.806a.412.412 0 01.408.407v1.091h-6.622l-.004-1.09z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.977 28.85h-3.005v-1.092a1.708 1.708 0 00-1.704-1.7h-5.806a1.7 1.7 0 00-1.701 1.7v1.091H7.257a.536.536 0 00-.536.537v5.367a.54.54 0 00.435.53h.021l9.526 1.879 1.557.303a.512.512 0 00.206 0l1.561-.307 5.078-1c-.05-1.224-.003-2.45.143-3.667.145-1.231.389-2.45.729-3.642zM15.05 27.757a.414.414 0 01.412-.407h5.806a.412.412 0 01.408.407v1.091h-6.622l-.004-1.09z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.512 36.001H17.22a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516h2.293a.516.516 0 00.516-.516v-1.45a.516.516 0 00-.516-.516z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.512 36.001H17.22a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516h2.293a.516.516 0 00.516-.516v-1.45a.516.516 0 00-.516-.516z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.053 74.516h21.291c.3 0 .544-.244.544-.544v-8.88c0-.3-.244-.544-.544-.544H74.053c-.3 0-.544.243-.544.543v8.88c0 .301.243.545.544.545z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M74.053 74.516h21.291c.3 0 .544-.244.544-.544v-8.88c0-.3-.244-.544-.544-.544H74.053c-.3 0-.544.243-.544.543v8.88c0 .301.243.545.544.545z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.056 64.552h21.288a.544.544 0 01.543.544v2.847L84.79 70.125a.513.513 0 01-.205 0l-11.087-2.182v-2.847a.544.544 0 01.558-.544z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.592 60.906h6.503v-1.09a1.705 1.705 0 011.701-1.702h5.81a1.704 1.704 0 011.7 1.701v1.091h6.5a.536.536 0 01.537.537v5.37a.54.54 0 01-.432.527L84.79 69.525c-.07.01-.14.01-.21 0L73.474 67.34a.54.54 0 01-.432-.526v-5.371a.536.536 0 01.55-.537zm14.422-1.09a.415.415 0 00-.408-.412h-5.81a.418.418 0 00-.411.411v1.091h6.622l.007-1.09z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.592 60.906h6.503v-1.09a1.705 1.705 0 011.701-1.702h5.81a1.704 1.704 0 011.7 1.701v1.091h6.5a.536.536 0 01.537.537v5.37a.54.54 0 01-.432.527L84.79 69.525c-.07.01-.14.01-.21 0L73.474 67.34a.54.54 0 01-.432-.526v-5.371a.536.536 0 01.55-.537zm14.422-1.09a.415.415 0 00-.408-.412h-5.81a.418.418 0 00-.411.411v1.091h6.622l.007-1.09z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.553 70.54h2.294c.284 0 .515-.23.515-.516v-1.45a.516.516 0 00-.515-.516h-2.294a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.553 70.54h2.294c.284 0 .515-.23.515-.516v-1.45a.516.516 0 00-.515-.516h-2.294a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.053 10.402h21.291c.3 0 .544-.243.544-.543V.979c0-.301-.244-.544-.544-.544H74.053c-.3 0-.544.243-.544.543v8.88c0 .3.243.544.544.544z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M74.053 10.402h21.291c.3 0 .544-.243.544-.543V.979c0-.301-.244-.544-.544-.544H74.053c-.3 0-.544.243-.544.543v8.88c0 .3.243.544.544.544z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.056.438h21.288a.544.544 0 01.544.543V3.83L84.791 6.01a.512.512 0 01-.206 0L73.513 3.83V.98a.544.544 0 01.543-.543z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.592-3.208h6.503V-4.3A1.704 1.704 0 0181.796-6h5.81a1.704 1.704 0 011.715 1.7v1.092h6.5a.537.537 0 01.536.536V2.7a.537.537 0 01-.432.526L84.79 5.397a.526.526 0 01-.21 0L73.474 3.212a.537.537 0 01-.432-.527v-5.357a.536.536 0 01.55-.536zM88.014-4.3a.412.412 0 00-.408-.411h-5.81a.415.415 0 00-.411.407v1.091h6.622l.007-1.087z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.592-3.208h6.503V-4.3A1.704 1.704 0 0181.796-6h5.81a1.704 1.704 0 011.715 1.7v1.092h6.5a.537.537 0 01.536.536V2.7a.537.537 0 01-.432.526L84.79 5.397a.526.526 0 01-.21 0L73.474 3.212a.537.537 0 01-.432-.527v-5.357a.536.536 0 01.55-.536zM88.014-4.3a.412.412 0 00-.408-.411h-5.81a.415.415 0 00-.411.407v1.091h6.622l.007-1.087z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.553 6.425h2.294c.284 0 .515-.231.515-.516v-1.45a.516.516 0 00-.515-.516h-2.294a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.553 6.425h2.294c.284 0 .515-.231.515-.516v-1.45a.516.516 0 00-.515-.516h-2.294a.516.516 0 00-.516.516v1.45c0 .285.231.516.516.516z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.84 42.463h18.507a.548.548 0 00.544-.547v-8.877a.539.539 0 00-.164-.384.537.537 0 00-.383-.16H77.82c.146 1.217.194 2.443.143 3.667 0 .198 0 .397-.031.592-.021.366-.053.736-.094 1.101a23.347 23.347 0 01-.997 4.608z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M76.84 42.463h18.507a.548.548 0 00.544-.547v-8.877a.539.539 0 00-.164-.384.537.537 0 00-.383-.16H77.82c.146 1.217.194 2.443.143 3.667 0 .198 0 .397-.031.592-.021.366-.053.736-.094 1.101a23.347 23.347 0 01-.997 4.608z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.82 32.495c.145 1.217.193 2.443.142 3.667 0 .198 0 .397-.031.592l5.116 1.004 1.562.307a.411.411 0 00.205 0l1.558-.304 9.525-1.875v-2.85a.588.588 0 00-.041-.21.45.45 0 00-.119-.17.537.537 0 00-.383-.16H77.819z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.088 28.85h3.008v-1.092a1.705 1.705 0 011.7-1.7h5.807a1.704 1.704 0 011.705 1.7v1.091h6.5a.537.537 0 01.536.537v5.367a.54.54 0 01-.432.53h-.024l-9.526 1.879-1.571.3a.512.512 0 01-.206 0l-1.561-.307-5.079-1c.1-2.471-.195-4.942-.87-7.32l.013.014zm10.926-1.092a.414.414 0 00-.41-.407h-5.807a.412.412 0 00-.408.407v1.091h6.622l.003-1.09z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M77.088 28.85h3.008v-1.092a1.705 1.705 0 011.7-1.7h5.807a1.704 1.704 0 011.705 1.7v1.091h6.5a.537.537 0 01.536.537v5.367a.54.54 0 01-.432.53h-.024l-9.526 1.879-1.571.3a.512.512 0 01-.206 0l-1.561-.307-5.079-1c.1-2.471-.195-4.942-.87-7.32l.013.014zm10.926-1.092a.414.414 0 00-.41-.407h-5.807a.412.412 0 00-.408.407v1.091h6.622l.003-1.09z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.553 38.484h2.294a.516.516 0 00.515-.515v-1.45a.516.516 0 00-.515-.516h-2.294a.516.516 0 00-.516.516v1.45c0 .284.231.515.516.515z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.553 38.484h2.294a.516.516 0 00.515-.515v-1.45a.516.516 0 00-.515-.516h-2.294a.516.516 0 00-.516.516v1.45c0 .284.231.515.516.515z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.956 30.331H37.363a.78.78 0 00-.781.78v12.76c0 .431.35.781.78.781h30.594a.78.78 0 00.781-.78v-12.76a.78.78 0 00-.78-.78zM56.832 28.051h-8.347a2.391 2.391 0 01-2.387-2.387V23.52a2.39 2.39 0 012.387-2.387h8.347a2.387 2.387 0 012.388 2.387v2.133a2.386 2.386 0 01-2.388 2.398zm-8.347-5.165a.645.645 0 00-.638.634v2.133a.645.645 0 00.645.645h8.347a.645.645 0 00.645-.645V23.52a.644.644 0 00-.645-.645l-8.354.01z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.953 30.331H37.366a.78.78 0 00-.784.78v4.096l15.928 3.137a.698.698 0 00.296 0l15.931-3.137v-4.095a.78.78 0 00-.784-.78z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.759 34.325l-15.96 3.136c-.099.018-.2.018-.3 0l-15.958-3.136a.774.774 0 01-.624-.757v-7.702a.77.77 0 01.77-.77H68.62a.77.77 0 01.77.77v7.716a.77.77 0 01-.63.743z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.31 35.374h-3.3a.739.739 0 00-.738.739V38.2c0 .408.33.738.738.738h3.3c.409 0 .74-.33.74-.738v-2.088a.739.739 0 00-.74-.739z",
    fill: "#00F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.31 35.374h-3.3a.739.739 0 00-.738.739V38.2c0 .408.33.738.738.738h3.3c.409 0 .74-.33.74-.738v-2.088a.739.739 0 00-.74-.739z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.199 38.232c.4.826.697 1.607 1.045 2.423.349.815.603 1.627.875 2.46a31.4 31.4 0 011.216 5.18c.035.219.053.456.077.696l.035.349V49.748a7.304 7.304 0 01-.136 1.575 16.99 16.99 0 01-.735 2.649 28.966 28.966 0 01-2.217 4.722l-1.771-.749c.394-1.59.792-3.21 1.091-4.775.147-.75.25-1.507.311-2.269.02-.311.013-.624-.021-.934l-.039-.22-.048-.278c-.039-.185-.063-.37-.109-.558a35.393 35.393 0 00-1.345-4.53c-.265-.757-.557-1.51-.85-2.266a65.574 65.574 0 00-.917-2.213l3.538-1.67z",
    fill: "#B47E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.665 57.48l-1.359 1.325 2.966 1.394s.718-1.255.223-2.39l-1.83-.328z",
    fill: "#B47E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.211 60.782l2.502 1.025 1.558-1.621-2.966-1.38-1.094 1.976z",
    fill: "#B47E4E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M55.447 59.353A25.095 25.095 0 1049.86 9.475a25.095 25.095 0 005.587 49.878z",
    fill: "#00A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.19 14.648L75.352 45.13a24.767 24.767 0 002.28-8.183L44.668 10.626a24.879 24.879 0 00-7.48 4.022zM28.386 28.006l35.877 28.666a25.093 25.093 0 008.636-7.416L33.72 17.944a25.095 25.095 0 00-5.333 10.062z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.475 62.598a3.73 3.73 0 00-.603-1.778 2.577 2.577 0 00-1.028-.91l-2.381-1.167c-1.582-.784-3.175-1.547-4.768-2.31-1.593-.764-3.196-1.513-4.792-2.27a240.33 240.33 0 00-4.82-2.213 421.457 421.457 0 00-9.724-4.259 207.71 207.71 0 00-4.914-2.021 2.039 2.039 0 01-1.196-2.517A28.952 28.952 0 1076.374 51a2.043 2.043 0 012.729-.582c1.524.906 3.055 1.797 4.593 2.673a376.467 376.467 0 009.292 5.123c1.558.844 3.137 1.656 4.688 2.482 1.55.826 3.136 1.63 4.715 2.44 1.579.808 3.137 1.6 4.737 2.38l2.373 1.178c.417.21.884.301 1.349.265a3.69 3.69 0 001.774-.603 3.935 3.935 0 001.851-3.757zm-71.926-7.71A22.842 22.842 0 1162.765 13.92a22.842 22.842 0 01-20.216 40.968z",
    fill: "#00A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.107 29.014c-.37 1.875-.736 5.308.575 6.555 0 0-.513 1.9-3.991 1.9-3.834 0-1.83-1.9-1.83-1.9 2.092-.498 2.036-2.049 1.67-3.485l3.576-3.07z",
    fill: "#B47E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.353 34.395c.29.094-.087 1.816-.087 1.816s-.477 1.202-6.41.784c-.456-.035-.281-1.687.154-1.928 1.405-.766 5.409-.979 6.343-.672z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.727 36.336c2.22 1.046 3.137 8.211 3.137 8.211l-5.106 2.004a40.929 40.929 0 01-1.92-5.977c-.715-3.234 1.606-5.325 3.889-4.238z",
    fill: "#00A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M109.727 36.336c2.22 1.046 3.137 8.211 3.137 8.211l-5.106 2.004a40.929 40.929 0 01-1.92-5.977c-.715-3.234 1.606-5.325 3.889-4.238z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.421 38.438a2.84 2.84 0 00-.544-.199 4.687 4.687 0 00-.021 2.335 40.662 40.662 0 001.917 5.978l1.683-.66c-.31-1.87-1.261-6.604-3.035-7.454z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.922 36.28s-2.725 3.078-.153 22.131h13.697c.094-2.09-1.227-12.358.801-22.263a35.808 35.808 0 00-4.586-.579 50.591 50.591 0 00-5.82 0 25.62 25.62 0 00-3.939.711z",
    fill: "#00A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M94.922 36.28s-2.725 3.078-.153 22.131h13.697c.094-2.09-1.227-12.358.801-22.263a35.808 35.808 0 00-4.586-.579 50.591 50.591 0 00-5.82 0 25.62 25.62 0 00-3.939.711z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.686 40.365c-.62-1.86-2.112-2.457-3.631-1.352-.307 1.806-.523 4.716-.276 9.33l2.674-.024s2.15-5.183 1.233-7.954z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.185 39.601a36.244 36.244 0 01-.436 2.663c-.17.882-.37 1.743-.596 2.61a29.927 29.927 0 01-1.82 5.165 15.96 15.96 0 01-1.066 1.907c-.185.29-.404.559-.651.798a4.624 4.624 0 01-1.673.993c-.505.177-1.028.3-1.558.366a12.87 12.87 0 01-2.855.035 13.406 13.406 0 01-1.359-.177c-.453-.08-.882-.164-1.349-.286l.227-1.91c1.59-.067 3.17-.3 4.712-.697.314-.093.618-.215.91-.363.191-.087.358-.22.487-.387-.027.025.227-.397.377-.697.15-.3.317-.697.46-1.045a24.1 24.1 0 00.774-2.255c.23-.777.432-1.569.62-2.37.188-.802.349-1.61.523-2.44.174-.83.3-1.652.425-2.422l3.848.512z",
    fill: "#B47E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.345 38.159c.722 2.339-2.206 9.31-2.206 9.31l-6.165-1.552a28.524 28.524 0 011.892-6.41c1.987-4.349 5.611-4.168 6.48-1.348z",
    fill: "#00A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.345 38.159c.722 2.339-2.206 9.31-2.206 9.31l-6.165-1.552a28.524 28.524 0 011.892-6.41c1.987-4.349 5.611-4.168 6.48-1.348z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.136 51.775l-2.9-.073 1.394 3.015s1.178.157 2.147-1.436l1.022-1.216-1.175-.237a2.877 2.877 0 00-.488-.053z",
    fill: "#B47E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.406 52.263l1.663 2.5 1.565-.046-1.398-3.015-1.83.561zM103.959 27.006c-.153 2.538-.111 4.03-1.394 5.333-1.924 1.959-5.057.801-5.663-1.743-.547-2.28-.202-6.043 2.28-7.058a3.462 3.462 0 014.777 3.468z",
    fill: "#B47E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 24.65s1.334.397.916 1.92c-.631 2.314-2.115 4.977-4.032 5.144-2.388.213-3.465-2.251-3.778-4.799-1.43-.98-2.489-1.896-2.147-2.914.523-1.568 2.418-2.92 5.437-2.572 3.018.349 4.52 2.3 3.604 3.22z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.568 27.438a2.871 2.871 0 01-.718 1.697c-.558.614-1.143.23-1.24-.516-.088-.676.093-1.808.776-2.146.684-.338 1.227.205 1.182.965z",
    fill: "#B47E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.627 58.411s-.864 17.26.819 24.571c2.666 11.578 14.387 20.856 14.387 20.856l3.764-3.015s-9.643-7.176-10.511-16.816c-.777-8.657.373-18.601.373-25.596h-8.832z",
    fill: "#00A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M99.627 58.411s-.864 17.26.819 24.571c2.666 11.578 14.387 20.856 14.387 20.856l3.764-3.015s-9.643-7.176-10.511-16.816c-.777-8.657.373-18.601.373-25.596h-8.832z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.913 63.525c-.348-.673-1.028 1.331-1.502 3.903 0 3.548.063 7.584.373 11.003 2.367-4.374 1.865-13.512 1.129-14.906z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.769 58.411s-3.855 16.346-4.127 24.153c-.303 8.758 2.75 29.412 2.75 29.412h4.34s.532-20.814.728-28.792c.209-8.695 5.311-24.773 5.311-24.773h-9.002z",
    fill: "#00A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M94.769 58.411s-3.855 16.346-4.127 24.153c-.303 8.758 2.75 29.412 2.75 29.412h4.34s.532-20.814.728-28.792c.209-8.695 5.311-24.773 5.311-24.773h-9.002z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empleado_svg__clip0_2572_59517"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h112v72H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "empleado_svg__clip1_2572_59517"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-3)",
    d: "M0 0h136v122H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/empleado.1d7b57a2.svg";
export { SvgEmpleado as ReactComponent };